// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {InfoTooltip} from 'sail/Tooltip';
import {BodyAlt} from 'sail/Text';

type XRaySidebarSectionProps = {|
  title: string,
  hint?: string,
  children: React.Node,
|};

export const XRaySidebarSection = ({
  title,
  hint,
  children,
}: XRaySidebarSectionProps) => (
  <Group spacing={4}>
    <label>
      <Group alignItems="center" direction="horizontal" spacing={4}>
        <BodyAlt color="gray">{title}</BodyAlt>
        {hint && (
          <InfoTooltip
            content={hint}
            position={{context: 'top', layer: 'bottomleft'}}
          />
        )}
      </Group>
    </label>
    {children}
  </Group>
);
